import React, { useRef, useState } from "react"
import { useMsal } from "@azure/msal-react";

import { Box } from "@mui/material";  
import{ type Baseline} from "./rheoadviseConfig";
import { fetchAvailableSkidsWithConfigHeaders,fetchBaseline, authenticatedFetch} from '../../Helper/Fetch/fetch';
import { Skid } from "../AvailableSkids/skidsWithConfigProvider";
import { loginRequest, protectedResources } from "../../authConfig";
import { getRheoServerUrl } from "../../Config/config";

interface BaselineProps{
    baseline: Baseline,
    skid:string,
    skidsWithConfig: Map<string, Skid>,

}
function BaselineConfig(props:BaselineProps){
    const { instance, inProgress,accounts } = useMsal();
    const request = {scopes: protectedResources.whoami.scopes,account: accounts[0]}
    const { baseline, skid, skidsWithConfig } = props
    const [calibration, setCalibration] = useState<number>(baseline?.CalibratedValue?baseline.CalibratedValue:0)
    // console.log('rendering baseline config with baseline:',baseline,'skid:',skidsWithConfig.get(skid))
     // console.log('skids with config:',skidsWithConfig)
     // console.log('skid_string:',skid)
    
     function pushBaseline(calibration:number){
        
            console.log('pushing baseline for skid:',skidsWithConfig.get(skid).name)
            const params =  new URLSearchParams({
                'Action':'addBaseline',
                'Skid':skidsWithConfig.get(skid).name,
                'Tag':baseline?.Tag,
                'CalibratedCalculatedValue': calibration.toString(),
                'CalibratedValue': calibration.toString()
            })
             const urlBase = getRheoServerUrl()
             const url = urlBase+'/rheoadvise'
             authenticatedFetch(request, instance, params, url).
             then((res)=>{
                 if(res.ok){
                     alert('Baseline updated successfully:'+res.statusText)
                 }else{
                     alert('Error updating baseline:'+res.statusText)
                 }
             })
    
        }
    return(
         <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-between', columnGap:5, background:'#0A1929', alignItems:'center' , p:1, borderRadius:2}}>
                    <p style={{color:'whitesmoke'}} color="white" >Tag: {baseline?.Tag}</p>
                    <p style={{color:'whitesmoke'}} color="white">LastCalibration:{baseline?.CalibrationTime.slice(0,-11)?baseline.CalibrationTime.slice(0,-11):'N/A'}</p>
                    <p style={{color:'whitesmoke'}} color="white">Median Baseline: {baseline?.MedianCalculatedValue?baseline.MedianCalculatedValue:0}</p>
                    {skidsWithConfig.get(skid).supervisor && (
                        <>
                        <p style={{color:'whitesmoke'}} color="white">Calibration: </p>
                        <input style={{maxWidth: '100px'}} type='number'  value={calibration} onChange={(e)=>setCalibration(parseFloat(e.target.value) || 0)}/>
                        </>
                    )}
                    {!skidsWithConfig.get(skid).supervisor && (
                        <p style={{color:'whitesmoke'}} color="white">Calibration: {calibration}</p>
                    )}
                    {skidsWithConfig.get(skid).supervisor && (
                        <button onClick={()=>{
                        console.log('setting ' + baseline?.Tag + ' baseline for skid:',skid)
                        pushBaseline(calibration)
                    }}>Set Baseline
                    </button>
                    )}
                    
                    
                </Box>
    )
}

export default BaselineConfig